export const CUSTOM_ROLE = { label: 'Custom', value: 'Custom' };
export const DEFAULT_PERMISSIONS = ['canViewOwnDetails', 'canChangeOwnDetails', 'canGetData'];
